export const calculateRevenueTotals = (data) => {
    return data.reduce((acc, item) => ({
      totalAmount: acc.totalAmount + item.totalAmount,
      theatrePayable: acc.theatrePayable + item.theatrePayable,
      platformEarnings: acc.platformEarnings + item.platformEarnings,
      count: acc.count + 1
    }), { totalAmount: 0, theatrePayable: 0, platformEarnings: 0, count: 0 });
  };
  